/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RequestHistory } from '../models/RequestHistory';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class HistoryService {
    /**
     * Request history list
     * Show history list
     * @returns any OK
     * @throws ApiError
     */
    public static requestHistoryList(): CancelablePromise<{
        items?: Array<RequestHistory>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/history/list',
        });
    }
}
